export default "__VITE_ASSET__CtoDLLbP__"